import React from "react";
import Tabs from "../../Components/Tabs";
import GetIcon from "../../utils/Icon";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
const FormLayout = ({
  title,
  breadcrumbs,
  status,
  finalStep,
  children,
  actionButtons
}) => {
  return (
    <>
      <Tabs />

      <div className="d-flex justify-content-between" style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
        <div className="d-flex align-items-center customizewidth">
          <Breadcrumb items={breadcrumbs} />
          <p className="m-0"><GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /></p>
          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px',color:'#270B79' }}>
            {title}

            {status !== "hide" &&  (
              <button
                className={`rounded-pill ${finalStep
                    ? 'greenbtnforstatus'
                    : (status === 'Draft' || status === 'New')
                      ? 'newdesign2343'
                      : 'greenbtnforstatus'
                  }`}
              >
                {finalStep
                  ? 'Submitted'
                  : status}
              </button>
            )}

          </a>
        </div>
        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }}>
          {actionButtons}
        </div>
      </div>
      {children}
    </>
  );
};

export default FormLayout;